import IdentityProviderButton from '../IdentityProviderButton'
import redirect from '../../utils/redirect'

const IdentityProviders = props => {
  const { identityProviders, brandAssetsURL, disabled } = props

  return Object.entries(identityProviders).map(([name, url]) => {
    return (
      <IdentityProviderButton
        key={name}
        name={name}
        url={url}
        brandAssetsURL={brandAssetsURL}
        redirect={redirect}
        disabled={disabled}
      />
    )
  })
}

export default IdentityProviders
